var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('b-table',{attrs:{"data":_vm.data,"columns":_vm.columns}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }